import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { SignalRService } from '@core/services/signal-r.service';
import { SubscripcionService } from '@core/services/subscripcion.service';
import { ConfigsService, EstablecimientosService, YaloService } from '@core/yalo';
import { MenuController } from '@ionic/angular';
import { UiService } from '@shared/ui';
import { environment } from 'src/environments/environment';
import { navigationData } from '../../common/navigation/data';
import { NavigationAppearance } from '../../common/navigation/navigation.types';
import { AvisosService } from '../../components/avisos/services/avisos.service';
import { User, UserService } from '@core/yalo/user';
import { PermisosUsuario } from '@core/types';
import Intercom from '@intercom/messenger-js-sdk';
import { LayoutService } from '../../layout.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js'; // Asegúrate de importar esto arriba

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainComponent implements OnInit, OnDestroy {
  navigation = navigationData;
  appearance: NavigationAppearance = 'dense';
  currentTitle = '';

  appVersion = environment.VERSION;
  user!: User;

  constructor(
    public readonly ui: UiService,
    private avisosService: AvisosService,
    private menuController: MenuController,
    private signalRService: SignalRService,
    private subscripcionService: SubscripcionService,
    private yalo: YaloService,
    private userService: UserService,
    private establecimientosService: EstablecimientosService,
    private config: ConfigsService,
    public layoutService: LayoutService,
    private router: Router,
  ) {

    this.userService.getUserOnce().subscribe((user) => {
      this.user = user;
     
      Intercom({
        app_id: 'uh2emjxl', 
        email: user.Correousuario || localStorage.getItem('Email'), // fallback por si acaso
        user_id: localStorage.getItem('CodUsuario'), // Puedes seguir incluyendo user_id si quieres
        name: user.NombreUsuario, // Nombre del usuario
        created_at: Math.floor(Date.now() / 1000),
         user_hash: user.UserHash // Aquí ya va tu hash de Identity Verification
      });
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateTitle();
    });
  }

  ngOnInit()
  {
    this.ui.canShowSidebar(true);
    this.avisosService.CargarAvisos();
    this.subscripcionService.VerificarSubscripcion();
    this.signalRService.InicializadorServidor();
    this.establecimientosService.getMisEstablecimientos().subscribe();
    this.establecimientosService.getMisEstablecimientosBodegas().subscribe();
    this.yalo.getNotifications().subscribe();
    this.subscripcionService.getSubscripcionInventarioPro()
    .subscribe({
      next: (resp) => {
        if (!resp) {
          const menuInventario = this.navigation.find(x => x.id === PermisosUsuario.gestion_compras);
          const indexDocumentos = menuInventario.children.findIndex(x => x.id === 'documentos');
          menuInventario.children.splice(indexDocumentos, 1) ;
        }
      },
      error: () => {
        const menuInventario = this.navigation.find(x => x.id === PermisosUsuario.gestion_compras);
        const indexDocumentos = menuInventario.children.findIndex(x => x.id === 'documentos');
        menuInventario.children.splice(indexDocumentos, 1) ;
      }
    });
  }

  ngOnDestroy() {
    this.signalRService.FinalizarServidor();
    this.establecimientosService.resetEstablecimientos();
    this.userService.resetUser();
  }

  toggleNavigation(): void {
    this.layoutService.hovered.next(!this.layoutService.hovered.value);
  }

  getCurrentBreakpoint = () => this.layoutService.getCurrentBreakpoint();

  toggleMenu() {
    this.menuController.toggle('menu-content');
  }

  /**
   * Toggle the navigation appearance
   */
  toggleNavigationAppearance(): void {
    this.appearance = this.appearance === 'default' ? 'dense' : 'default';
  }

  private updateTitle(): void {
    //titulo dinamico segun navigation
    const currentRoute = this.router.url;
    // const menuItem = this.navigation.find(item =>
    //   currentRoute.includes(item.link) ||
    //   item.children?.some(child => currentRoute.includes(child.link))
    // );

    // if (menuItem?.children) {
    //   this.currentTitle = menuItem.children.find(child =>
    //     currentRoute.includes(child.link)
    //   )?.title ?? menuItem.title;
    // } else {
    //   this.currentTitle = menuItem?.title ?? '';
    // }
    if (currentRoute.includes('/estadisticas')) {
      this.currentTitle = 'Estadisticas';
    } else {
      this.currentTitle = '';
    }
  }
}
